// Imports => Dependencies
import { createContext } from 'react';
import { makeObservable, observable, action } from 'mobx';

// Imports => API
import createApi from '@api';

// Imports => Stores
import AuthStore from '@stores/auth.store';
import GlobalStore from '@stores/global.store';
import ProfileStore from '@stores/profile.store';
import UserStore from '@stores/user.store';
import ToastersStore from '@stores/toasters.store';
import UiStore from '@stores/ui.store';

import TicketsStore from '@stores/tickets.store';
import TransactionsStore from '@stores/transactions.store';
import MovementsStore from '@stores/movements.store';
import WithdrawalsStore from '@stores/withdrawals.store';
import PurchasesStore from '@stores/purchases.store';
import BalanceStore from '@stores/balance.store';
import ComplianceRequirementsStore from '@stores/compliance-requirements.store';
import SettingsStore from '@stores/settings.store';

class Store {
  constructor(config) {
    makeObservable(this);

    this.config = config;

    this.api = createApi(config);

    // this.auth = new AuthStore(this);
    this.global = new GlobalStore(this);
    this.profile = new ProfileStore(this);
    this.user = new UserStore(this);
    this.toasters = new ToastersStore(this);
    this.ui = new UiStore(this);

    this.tickets = new TicketsStore(this);
    this.transactions = new TransactionsStore(this);
    this.movements = new MovementsStore(this);
    this.withdrawals = new WithdrawalsStore(this);
    this.purchases = new PurchasesStore(this);

    this.balance = new BalanceStore(this);

    this.compliance_requirements = new ComplianceRequirementsStore(this);
    this.settings = new SettingsStore(this);
  }

    @action
      resetStores = () => {
        return new Promise((resolve) => {
          resolve();
        });
      };

    @observable
      swUpdated = false;
}

export default Store;
